module.exports = __webpack_public_path__ + "static/media/app-store.5aac4169.svg";